import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/system';
import { baseModalDialogSx } from 'styles/sx/dialogSx';

const StyledDialog = styled(Dialog)({ ...baseModalDialogSx });

export function ModalDialog(props) {
  return <StyledDialog maxWidth="xs" {...props} />;
}
